import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Warning } from "@phosphor-icons/react";

/**
 * 21+ age-gate modal. Shows on first visit, persists confirmation in localStorage.
 * Required for the public-facing prediction service per legal compliance.
 */
const STORAGE_KEY = "diamond_age_confirmed_v1";

export default function AgeGate() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const ok = localStorage.getItem(STORAGE_KEY);
      if (!ok) setOpen(true);
    } catch {
      setOpen(true);
    }
  }, []);

  const confirm = () => {
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch {}
    setOpen(false);
  };
  const deny = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-md flex items-center justify-center p-6"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          data-testid="age-gate-modal"
        >
          <motion.div
            initial={{ scale: 0.94, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
            className="max-w-md w-full bg-[#0A0A0A] border border-[#007AFF]/40 rounded-sm p-7"
          >
            <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-[#FF3B30] mb-3">
              <Warning size={14} weight="fill" /> Age-restricted content
            </div>
            <h2 className="font-display text-3xl leading-[0.95] mb-3">
              ARE YOU<br />
              <span className="text-[#007AFF]">21 OR OLDER?</span>
            </h2>
            <p className="text-xs text-zinc-400 leading-relaxed mb-5">
              Accurate Monkey publishes signal-driven predictions across sports (MLB, WNBA) and financial markets (stocks, options) for entertainment and informational purposes only.
              By continuing you confirm you are at least 21 years old and acknowledge this is not financial or wagering advice.
              Predictions should never be used as the sole basis for any trading or wagering decision. Always trade &amp; wager responsibly —
              if you or someone you know has a gambling problem, call <span className="text-white">1-800-GAMBLER</span>.
            </p>
            <div className="grid grid-cols-2 gap-3">
              <button
                onClick={deny}
                data-testid="age-gate-deny"
                className="py-3 border border-white/15 hover:border-[#FF3B30]/50 hover:text-[#FF3B30] text-zinc-300 text-xs uppercase tracking-wider rounded-sm transition-colors"
              >
                Under 21 · Exit
              </button>
              <button
                onClick={confirm}
                data-testid="age-gate-confirm"
                className="py-3 bg-[#007AFF] hover:bg-[#0064D6] text-white text-xs uppercase tracking-wider font-bold rounded-sm transition-colors"
              >
                I&apos;m 21+ · Enter
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
